import styled from 'styled-components'
import { createStyledText } from './Text'

const Container = styled.input`
  width: 100%;
  height: 54px;
  padding: 8px 16px;
  background-color: ${(props) => props.theme.colors.neutral[100]}; 
  outline: none; // 기본 css 설정 초기화
  border: 1px solid ${(props) => props.theme.colors.neutral[400]};
  border-radius: 10px;
  text-align: center;
  
  // input value 텍스트 설정
  ${({ theme }) =>
    createStyledText({ theme, variant: "headline3", weight: "medium" })}
`
const CardWordInput = ({value, ...props}) => {
  return (
    <Container
      value={value}
      readOnly
      {...props}
    />
  )
}

export default CardWordInput
